module.exports = __webpack_public_path__ + "img/mb-who-are-we-pic1.ce4c56b3.png";